/* vim: set ts=2 sw=2 sts=2 et: */

/**
 * Copyright (c) 2001-present X-Cart Holdings LLC. All rights reserved.
 * See https://www.x-cart.com/license-agreement.html for license details.
 */

import fetchPageData from './fetch';
import appConfig from '../../config/app-config';

const url = `${appConfig.url}/service.php/api/modules`;

export const fetchModulesPage = params => fetchPageData(url, params, 'modules');

export const fetchModuleById = (id, params) => {
  const paramsStr = params ? new URLSearchParams(params).toString() : '';
  return fetch(`${url}/byModuleId/${id}?${paramsStr}`)
    .then(async (response) => {
      let data = await response.json().then(jsonData => jsonData);
      let result = {};

      if (!response.ok) {
        const error = (data && data.message) || response.statusText;
        return Promise.reject(error);
      }

      // Remove key recursively
      data = JSON.parse(JSON.stringify(data, (keyToRemove, v) => ((keyToRemove === 'hydra:view') ? undefined : v)));

      result = {
        id: data.id,
        module: data,
      };

      return result;
    });
};



// WEBPACK FOOTER //
// ./src/api/modules.js